import { render, staticRenderFns } from "./report-widget-edit.vue?vue&type=template&id=1e0223a4&scoped=true"
import script from "./report-widget-edit.vue?vue&type=script&lang=js"
export * from "./report-widget-edit.vue?vue&type=script&lang=js"
import style0 from "./report-widget-edit.vue?vue&type=style&index=0&id=1e0223a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0223a4",
  null
  
)

export default component.exports